/* EVENTS */
export const GET_CLINIC = "GET_CLINIC"
export const GET_CLINIC_SUCCESS = "GET_CLINIC_SUCCESS"
export const GET_CLINIC_FAIL = "GET_CLINIC_FAIL"

export const GET_CLINIC_DETAILS = "GET_CLINIC_DETAILS"
export const GET_CLINIC_DETAILS_SUCCESS = "GET_CLINIC_DETAILS_SUCCESS"
export const GET_CLINIC_DETAILS_FAIL = "GET_CLINIC_DETAILS_FAIL"

export const ADD_NEW_CLINIC = "ADD_NEW_CLINIC"
export const ADD_CLINIC_SUCCESS = "ADD_CLINIC_SUCCESS"
export const ADD_CLINIC_FAIL = "ADD_CLINIC_FAIL"

export const UPDATE_CLINIC = "UPDATE_CLINIC"
export const UPDATE_CLINIC_SUCCESS = "UPDATE_CLINIC_SUCCESS"
export const UPDATE_CLINIC_FAIL = "UPDATE_CLINIC_FAIL"

export const DELETE_CLINIC = "DELETE_CLINIC"
export const DELETE_CLINIC_SUCCESS = "DELETE_CLINIC_SUCCESS"
export const DELETE_CLINIC_FAIL = "DELETE_CLINIC_FAIL"



export const RESET_CLINIC_STATE = 'RESET_CLINIC_STATE';
